import Vue from "vue";
import Router from "vue-router";
import Layout from "../views/layout/Layout";


Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Index",
        component: () => import("../views/step/Index")
      },
      {
        path: "/indexGYMS",
        name: "IndexGYMS",
        component: () => import("../views/step/IndexGYMS")
      },
    ]
  },
  
  {
    path: "/login",
    name: "TeacherLogin",
    component: () => import("../views/operator/TLogin")
  },

  {
    path: "/t/zhuanyeCount",
    name: "ZhuanyeCount",
    component: () => import("../views/operator/zhuanyeCount")
  },
  {
    path: "/t/banjiCount",
    name: "BanjiCount",
    component: () => import("../views/operator/banjiCount")
  },
  {
    path: "/t/studentLists",
    name: "StudentLists",
    component: () => import("../views/operator/TStudentLists")
  },
  {
    path: "/t/studentListsGYMS",
    name: "StudentLists",
    component: () => import("../views/operator/TStudentListsGYMS")
  },
  {
    path: "/t/studentBanji",
    name: "studentBanji",
    component: () => import("../views/operator/TStudentBanji")
  },
  {
    path: "/t/studentInfo",
    name: "StudentInfo",
    component: () => import("../views/operator/TStudentInfo")
  },
  {
    path: "/t/TStudentTzbjInfo",
    name: "TStudentTzbjInfo",
    component: () => import("../views/operator/TStudentTzbjInfo")
  },
  {
    path: "/searchStudent",
    name: "SearchStudent",
    component: () => import("../views/step/SearchStudent")
  },
  {
    path: "/add",
    name: "AddStudent",
    component: () => import("../views/step/AddStudent"),
    meta: { content: "user-scalable=no" }
  },
  {
    path: "/addGyms",
    name: "AddStudentGYMS",
    component: () => import("../views/step/AddStudentGYMS"),
    meta: { content: "user-scalable=no" }
  },
  {
    path: "/comfirmRegisterNotice",
    name: "ComfirmRegisterNotice",
    component: () => import("../views/step/ConfirmStudentRegisterNotice"),
    meta: { content: "user-scalable=no" }
  },
  {
    path: "/edit",
    name: "EditStudent",
    component: () => import("../views/step/EditStudent"),
    meta: { name: "viewport", content: "user-scalable=no" }
  },
  {
    path: "/confirm",
    name: "ConfirmStudent",
    component: () => import("../views/step/ConfirmStudent"),
    meta: { name: "viewport", content: "user-scalable=no" }
  },
  {
    path: "/ldedit",
    name: "LdEditStudent",
    component: () => import("../views/step/LdEditStudent")
  },
  {
    path: "/pay",
    name: "PayCharge",
    component: () => import("../views/step/PayCharge")
  },
  {
    path: "/payYD",
    name: "PayChargeYD",
    component: () => import("../views/step/PayChargeYD")
  },
  {
    path: "/payLzjdgy",
    name: "PayLzjdgy",
    component: () => import("../views/step/PayLzjdgy")
  },
  {
    path: "/prepay",
    name: "PrePayCharge",
    component: () => import("../views/step/PrePayCharge")
  },
  {
    path: "/ruxuexuzhi",
    name: "ruxuexuzhi",
    component: () => import("../views/step/ruxuexuzhi")
  },
  {
    path: "/finish",
    name: "SignFinish",
    component: () => import("../views/step/SignFinish")
  },
  {
    path: "/jianjie/lists",
    name: "JianJieLists",
    component: () => import("../views/jianjie/Lists")
  },
  {
    path: "/jianjie/detail",
    name: "JianJieDetail",
    component: () => import("../views/jianjie/Detail")
  },

  {
    path: "/getNotice",
    name: "GetNotice",
    component: () => import("../views/step/GetNotice")
  },
  {
    path: "/preRegisterLogin",
    name: "PreRegisterLogin",
    component: () => import("../views/step/PreRegisterLogin")
  },
  {
    path: "/Notice",
    name: "Notice",
    component: () => import("../views/step/Notice")
  },
  {
    path: "/contactOnline",
    name: "ContactOnline",
    component: () => import("../views/step/ContactOnline")
  },
  {
    path: "/admissionInfo",
    name: "AdmissionInfo",
    component: () => import("../views/step/AdmissionInfo"),
    meta: { content: "user-scalable=no" }
  },
  {
    path: "/student",
    name: "Student",
    redirect: "/student/home",
    component: () => import("../views/student/index"),
    children: [
      {
        path: "/student/home",
        name: "StudentHome",
        component: () => import("../views/student/home/index")
      },
      {
        path: "/student/mine",
        name: "StudentMine",
        component: () => import("../views/student/mine/index")
      }
    ]
  },
  {
    path: "/mail",
    name: "Mail",
    component: () => import("../views/student/component/mail.vue")

  },
  {
    path: "/uploadImage",
    name: "UploadImage",
    component: () => import("../views/student/component/uploadImage.vue")
  },
  {
    path: "/changeMajor",
    name: "ChangeMajor",
    component: () => import("../views/student/component/changeMajor.vue")

  },
  {
    path: "/wholeRefund",
    name: "WholeRefund",
    component: () => import("../views/student/component/wholeRefund.vue")

  },
  {
    path: "/toPay",
    name: "ToPay",
    component: () => import("../views/wechat/toPay.vue")
  },
  {
    path: "/channelReport",
    name: "ChannelReport",
    component: () => import("../views/operator/components/channelReport.vue")
  },
  {
    path: "/studentReport",
    name: "StudentReport",
    component: () => import("../views/operator/components/studentReport.vue")
  }
  ,
  {
    path: "/reportManage",
    name: "ReportManage",
    component: () => import("../views/operator/components/reportManage.vue")
  },
  {
    path: "/updatePassword",
    name: "UpdatePassword",
    component: () => import("../views/operator/components/updatePassword.vue")
  },
  {
    path: "/studentInfo/:id",
    name: "ReportStudentInfo",
    component: () => import("../views/operator/components/studentInfo.vue")
  },
  {
    path: "/channelInfo/:id",
    name: "ReportChannelInfo",
    component: () => import("../views/operator/components/channelInfo.vue")
  },
  {
    path: "/chargeInfo/:id",
    name: "ReportChangeInfo",
    component: () => import("../views/operator/components/chargeInfo.vue")
  },
  {
    path: "/applyInfo/:id",
    name: "ApplyInfo",
    component: () => import("../views/operator/components/applyInfo.vue")
  },
  {
    path: "/editSign",
    name: "EditSignStudent",
    component: () => import("../views/step/EditSignStudent.vue")
  },
  {
    path: "/bill",
    name: "Bill",
    component: () => import("../views/student/component/bill.vue")
  },
  {
    path: "/billForNewCharge",
    name: "BillForNewCharge",
    component: () => import("../views/student/component/billForNewCharge.vue")
  },
  {
    path: "/refund",
    name: "Refund",
    component: () => import("../views/student/component/refund.vue")
  },
  {
    path: "/doRefund",
    name: "DoRefund",
    component: () => import("../views/student/component/doRefund.vue")
  },
  {
    path: "/studentChangeClassLogin",
    name: "StudentChangeClassLogin",
    component: () => import("../views/step/student-change-class-login.vue")
  },
  {
    path: "/qrIndex",
    name: "QRIndex",
    component: () => import("../views/qr-code/index.vue")
  }

]
const router = new Router({
  mode: "history", // 后端支持可开 /operator/
  base: "/phone",
  // mode: "hash",
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js